import { render, staticRenderFns } from "./AccountManagerPerformance.vue?vue&type=template&id=42cb2a2c&scoped=true&"
import script from "./AccountManagerPerformance.vue?vue&type=script&lang=js&"
export * from "./AccountManagerPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb2a2c",
  null
  
)

export default component.exports